import { ArrowRight } from "lucide-react";
import { BRAND } from "../../data/mock";

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden pt-40 pb-20 sm:pt-48 sm:pb-24" data-testid="hero-section">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[500px] w-[900px] rounded-full bg-[#1e6bff]/15 blur-[140px]" />
        <div className="absolute inset-0 hero-grid" />
      </div>

      <div className="relative mx-auto max-w-5xl px-4 text-center">
        <div
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs sm:text-sm text-zinc-300 animate-fade-up"
          data-testid="hero-badge"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-[#2f7fff] animate-pulse" />
          {BRAND.badge}
        </div>

        <h1
          className="font-heading mt-8 text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight text-white uppercase animate-fade-up"
          style={{ animationDelay: "0.1s" }}
          data-testid="hero-title"
        >
          {BRAND.logoFirst}
          <span className="text-gradient-blue">{BRAND.logoAccent}</span>
          {BRAND.logoSecond}
        </h1>

        <p
          className="mt-6 text-base md:text-lg text-zinc-400 animate-fade-up"
          style={{ animationDelay: "0.2s" }}
          data-testid="hero-subtitle"
        >
          {BRAND.heroSubtitle}
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up"
          style={{ animationDelay: "0.3s" }}
        >
          <a
            href="#products"
            className="group inline-flex items-center gap-2 rounded-full bg-[#2f7fff] hover:bg-[#4b91ff] text-white font-semibold px-7 py-3.5 transition-colors"
            data-testid="hero-primary-cta"
          >
            {BRAND.ctaPrimary}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="#proof"
            className="inline-flex items-center rounded-full border border-white/15 bg-white/5 hover:bg-white/10 text-white font-medium px-7 py-3.5 transition-colors"
            data-testid="hero-secondary-cta"
          >
            {BRAND.ctaSecondary}
          </a>
        </div>
      </div>
    </section>
  );
};
